import { reactive } from 'vue'
import TokenService from './tokenService'

const state = reactive({ ws: null, ready: false })

export function initChatWebSocket() {
  if (state.ws) return
  state.ready = false
  const ws = new WebSocket(
    `wss://${
      location.port ? 'dev.checkmarq.net' : location.host
    }/api/ws/v1/chats/?token=${TokenService.getLocalAccessToken()}`
  )
  ws.onopen = () => {
    state.ready = true
  }
  ws.onclose = () => {
    state.ws = null
    state.ready = false
  }
  state.ws = ws
}

export function closeChatWebSocket() {
  state.ws?.close()
  state.ws = null
  state.ready = false
}

export default state
